<template>
  <el-form
    ref="formRef"
    :inline="false"
    label-position="right"
    label-width="auto"
    :model="formModel"
    class=""
    :disabled="disabled"
  >
    <el-row class="row">
      <template v-for="formItem in formData" :key="formItem.fieldName">
        <el-col :span="formItem.span || _formConfig.span">
          <slot
            v-if="formItem.layout"
            :name="formItem.fieldName"
            :item="formItem"
          />
          <el-form-item
            v-else
            :rules="formItem.rules"
            :prop="formItem.fieldName"
            :label="
              (formItem.label ?? '') + (formItem.sign || _formConfig.sign)
            "
          >
            <div v-if="formItem.type === 'text'">
              {{
                formItem.formatter
                  ? catchError(
                      formItem.formatter,
                      formModel,
                      formModel?.[formItem.fieldName]
                    )
                  : formModel?.[formItem.fieldName]
              }}
            </div>
            <template v-else-if="!!formItem.customize">
              <slot
                :name="formItem.fieldName"
                :item="formItem"
                :formModel="formModel"
              />
              <!-- :disable="isDisabled(item)" -->
            </template>
            <Control
              v-else
              :formItem="formItem"
              v-model="formModel[formItem.fieldName]"
            ></Control>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </el-form>
</template>
<script lang="ts" setup>
import {
  useAttrs,
  ref,
  computed,
  reactive,
  onBeforeUpdate,
  nextTick,
  onBeforeUnmount,
  onMounted,
} from "vue";
import { useVModel } from "@vueuse/core";
const attrs: any = useAttrs();
const props = defineProps({
  formConfig: Object,
  formModel: {
    type: Object,
    default: () => {},
  },
  formData: {
    type: Array,
    default: () => {
      return [];
    },
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const formData = computed(() => {
  return props.formData.filter((item) => !item.hidden);
});
const emit = defineEmits(["onFormMounted", "handleEvent", "update:formModel"]);
const _formConfig = computed(() => {
  const defaultConfig: Record<string, any> = {
    span: 24,
    sign: ":",
    // gutter: 24,
  };
  return {
    ...defaultConfig,
    ...props.formConfig,
  };
});

const formModel = useVModel(props, "formModel", emit);
const formRef = ref();
onMounted(() => {
  emit("onFormMounted", formRef.value);
});
const catchError = (fn, ...args) => {
  try {
    return fn(...args);
  } catch (error) {
    console.log("error:", error);
  }
};
// const formModel: Record<string, any> = reactive({});
// const formHidden: Record<string, any> = reactive({});
// const _sync =
//   (func: any) =>
//   (fieldName: string[] | string, value: any, { sync = false, ...rest } = {}) =>
//     sync
//       ? func(fieldName, value, { ...rest })
//       : nextTick(() => func(fieldName, value, { ...rest }));

// const isArrayExecFunction =
//   (func: any) =>
//   (fieldName: string[] | string, ...rest) =>
//     Array.isArray(fieldName)
//       ? fieldName.forEach((item) => func(item, ...rest))
//       : func(fieldName, ...rest);

// filter 包含的值会被设置为 “-” 默认为包裹nextTick的
// const setFormModel = _sync(
//   isArrayExecFunction(
//     (fieldName: string, value: any = "", { filter = [] } = {} as any) => {
//       formModel[fieldName] =
//         filter.length > 0 && filter.includes(value) ? "-" : value;
//     }
//   )
// );

// const setDefaultValue = () => {
//   props.formData.forEach((item) => {
//     const { fieldName, defaultValue, hidden, disabled, label } = item;
//     if (formModel[fieldName] === undefined || formModel[fieldName] === null) {
//       setFormModel(fieldName, defaultValue);
//     }
//   });
// };

// setDefaultValue();
onBeforeUnmount(() => {
  for (const key of Object.keys(formModel.value)) {
    delete formModel.value[key];
  }
});
const setDefaultValue = () => {
  formData.value.forEach((item) => {
    const { fieldName, defaultValue, hidden, disabled, label } = item;
    if (
      formModel.value[fieldName] === undefined ||
      formModel.value[fieldName] === null
    ) {
      formModel.value[fieldName] = defaultValue;
      // setFormHidden(fieldName, hidden);
      // setFormLabel(fieldName, label);
      // setFormDisabled(fieldName, disabled);
    }
  });
};
setDefaultValue();
defineExpose({
  // formValidate,
  // formResetFields,
  // formClearValidate,
  //   setFormModel,
  // setFormLabel,
  // setFormHidden,
  // setFormDisabled,
  // setFormDisabledAll,
  // itemRefs,
  // formRef,
  // getFormModel,
});
</script>
